/* VAYNEWEAR Bottomwear: exact selected-colour media filtering. */
(() => {
  if (window.__vyExactBottomwearGallery) return;
  window.__vyExactBottomwearGallery = true;

  const normalize = (value) =>
    String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

  const selectedColor = (root) => {
    for (const fieldset of root.querySelectorAll('variant-selects fieldset')) {
      const legend = normalize(fieldset.querySelector('legend')?.textContent);
      if (!legend.startsWith('color') && !legend.startsWith('colour')) continue;
      return String(fieldset.querySelector('input:checked')?.value || '').trim();
    }
    for (const select of root.querySelectorAll('variant-selects select')) {
      const name = normalize(select.dataset.optionName || select.previousElementSibling?.textContent);
      if (name.startsWith('color') || name.startsWith('colour')) return String(select.value || '').trim();
    }
    return '';
  };

  const colorValues = (root) => {
    const values = [];
    const seen = new Set();
    root.querySelectorAll('variant-selects fieldset').forEach((fieldset) => {
      const legend = normalize(fieldset.querySelector('legend')?.textContent);
      if (!legend.startsWith('color') && !legend.startsWith('colour')) return;
      fieldset.querySelectorAll('input').forEach((input) => {
        const value = String(input.value || '').trim();
        const key = normalize(value);
        if (value && !seen.has(key)) {
          seen.add(key);
          values.push(value);
        }
      });
    });
    root.querySelectorAll('variant-selects select').forEach((select) => {
      const name = normalize(select.dataset.optionName || select.previousElementSibling?.textContent);
      if (!name.startsWith('color') && !name.startsWith('colour')) return;
      Array.from(select.options).forEach((option) => {
        const value = String(option.value || option.textContent || '').trim();
        const key = normalize(value);
        if (value && !seen.has(key)) {
          seen.add(key);
          values.push(value);
        }
      });
    });
    return values.sort((a, b) => normalize(b).length - normalize(a).length);
  };

  const imageColor = (item, colors) => {
    const alt = normalize(item.querySelector('img')?.alt || item.getAttribute('alt') || '');
    return colors.find((color) => {
      const key = normalize(color);
      return alt === key || alt.endsWith(` ${key}`) || alt.includes(` ${key} `);
    }) || '';
  };

  const apply = (root) => {
    const color = selectedColor(root);
    const colors = colorValues(root);
    if (!color || colors.length < 2) return;

    const gallery = root.querySelector('media-gallery');
    if (!gallery) return;

    const slides = Array.from(gallery.querySelectorAll('.product__media-list .product__media-item'));
    const matches = slides.filter((slide) => normalize(imageColor(slide, colors)) === normalize(color));
    if (!matches.length) return;

    slides.forEach((slide) => {
      const show = matches.includes(slide);
      slide.hidden = !show;
      slide.style.setProperty('display', show ? '' : 'none', show ? '' : 'important');
      slide.setAttribute('aria-hidden', show ? 'false' : 'true');
      slide.classList.toggle('is-active', show && slide === matches[0]);
    });

    const visibleIds = new Set(matches.map((slide) => slide.dataset.mediaId).filter(Boolean));
    gallery.querySelectorAll('.thumbnail-list__item, .thumbnail-slider li').forEach((thumb) => {
      const show = !thumb.dataset.target || visibleIds.has(thumb.dataset.target);
      thumb.hidden = !show;
      thumb.style.setProperty('display', show ? '' : 'none', show ? '' : 'important');
      thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
    });

    const first = matches[0];
    if (first?.dataset.mediaId) {
      gallery.setActiveMedia?.(first.dataset.mediaId, true);
    }

    gallery.elements?.viewer?.resetPages?.();
    gallery.elements?.thumbnails?.resetPages?.();

    const current = gallery.querySelector('.slider-counter--current');
    const total = gallery.querySelector('.slider-counter--total');
    if (current) current.textContent = '1';
    if (total) total.textContent = String(matches.length);

    const sectionId = root.dataset.section;
    const modal = sectionId ? document.getElementById(`ProductModal-${sectionId}`) : null;
    if (modal) {
      modal.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((item) => {
        item.hidden = normalize(imageColor(item, colors)) !== normalize(color);
      });
    }
  };

  let timer;
  const applyAll = () => document.querySelectorAll('product-info').forEach(apply);
  const schedule = () => {
    clearTimeout(timer);
    requestAnimationFrame(applyAll);
    timer = setTimeout(applyAll, 300);
  };

  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('variant-selects input, variant-selects select')) schedule();
  });
  document.addEventListener('shopify:section:load', schedule);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  }

  const init = () => applyAll();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
